import { nodeListToArray, nodeMatches } from '../utils'
import { ArticleGallery } from '../../components/molecule/ArticleContent/entry'
import { h } from '../parser/utils'

import { parseImgProps } from './img'
import { parseCaption } from './blocks/image'

export const NAME = 'gallery'

export const COMPONENTS = {
  ArticleGallery,
}

export function matches(node) {
  return nodeMatches(node, '.gallery')
}

export async function transform (node, next, ctx) {
  const items = node.querySelectorAll('.gallery-item')

  let hasLink = false

  const captionPromises = []

  const entries = nodeListToArray(items).map((item, idx) => {
    captionPromises[idx] = parseCaption(
      item.querySelector('.gallery-caption'),
      next,
      ctx,
    )

    hasLink = hasLink || item.querySelector('.gallery-icon a').length !== 0

    const picture = parseImgProps(
      item.querySelector('.gallery-icon img'),
      ctx,
      ['id', 'class'],
    )

    return { picture }
  })

  const captions = await Promise.all(captionPromises)

  entries.forEach((entry, idx) => {
    entry.caption = captions[idx]?.length ? captions[idx] : undefined
  })

  const props = {
    offset: true,
    boxed: {
      padded: true,
      withBackground: true,
    },
    lightbox: hasLink,
    entries,
  }

  return h(ArticleGallery, props)
}
